<template>
  <div class="main">
    <div class="mt">
      <a @click="jumpMap(device)" class="btn-nav">
        导航寻路
      </a>
      <div class="location text-ellipsis">
        <img src="@/assets/img/ic_menu_mapoint_pressed.png" alt="" />
        {{ device.name }}
      </div>
    </div>
    <div class="mc">
      <div class="hd">
        <div class="search-box">
          <img src="@/assets/img/ic_common_search_normal.png" alt="" />
          <input
            type="search"
            @keypress="searchBtn"
            v-model="bookName"
            placeholder="输入书籍名称"
          />
        </div>
      </div>
      <div class="bd">
        <ul class="tab">
          <li :class="{ active: type == 0 }">
            <a @click="clickType(0)">
              首字母
            </a>
          </li>
          <li :class="{ active: type != 0 }">
            <a @click="clickType(1)">
              最新上架
            </a>
          </li>
        </ul>
        <ul class="bookList">
          <li v-for="item in items">
            <a @click="jumpBook(item.id, device.id)" class="bookItem">
              <img :src="item.cover" style="height:2.34rem" alt="" />
              <p class="text-ellipsis">
                {{ item.name }}
              </p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="mb">
      <ul class="nav-tab">
        <li class="on">
          <a @click="() => $router.push({ name: 'Books' })">
            <img src="@/assets/img/tab1_on.png" alt="" />
            <p>图书信息</p>
          </a>
        </li>
        <li>
          <a @click="() => $router.push({ name: 'Devices' })">
            <img src="@/assets/img/tab2.png" alt="" />
            <p>地址找书</p>
          </a>
        </li>
        <li>
          <a @click="() => $router.push({ name: 'Center' })">
            <img src="@/assets/img/tab3.png" alt="" />
            <p>个人中心</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import { getDeviceBooks, getDevices } from "@/api/device";
import { wxJsInfo } from "@/api/wechat";
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      device: {},
      type: 0,
      items: [],
      bookName: "",
      location: {
        lng: 116.404,
        lat: 39.915,
      },
    };
  },
  methods: {
    clickType(type) {
      this.type = type;
      this.handleBooks(this.device.id);
    },
    handleBooks(deviceId) {
      getDeviceBooks({
        type: this.type,
        deviceId: deviceId,
        name: this.bookName,
      }).then((res) => {
        this.items = [];
        for (var i = 0; i < res.data.content.length; i++) {
          var item = new Object();
          item.id = res.data.content[i].id;
          item.name = res.data.content[i].name;
          item.cover =
            process.env.VUE_APP_RESOURCE_API + res.data.content[i].cover;
          this.items.push(item);
        }
      });
    },
    searchBtn(event) {
      if (event.keyCode == 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        console.log(event.target.value);
        var search_val = event.target.value;
        if (this.bookName == "" || this.bookName == null) {
          // alert('搜索内容不能为空');
        } else {
          this.handleBooks(this.device.id);
        }
      }
    },
    jumpMap(marker) {
      console.log("jumpMap",marker)
      // window.location =
      //   "https://api.map.baidu.com/marker?location=" +
      //   marker.lat +
      //   "," +
      //   marker.lng +
      //   "&title=" +
      //   marker.name +
      //   "&output=html";
        wx.openLocation({
          latitude: Number(marker.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: Number(marker.lng), // 经度，浮点数，范围为180 ~ -180。
          name: marker.name, // 位置名
          address: marker.address, // 地址详情说明
          scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        });

    },
    jumpBook(bookId, deviceId) {
      this.$router.push({
        path: "/book",
        query: { id: bookId, deviceId: deviceId },
      });
    },
  },
  mounted() {
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }

    console.log("url",window.location.href.split('#')[0])
    var params = {"url":window.location.href.split('#')[0]}
    wxJsInfo(params).then(res =>{
      wx.config({
　　　　debug: false, // 开启调试模式,
　　　　appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
　　　　timestamp: res.data.timestamp, // 必填，生成签名的时间戳
　　　　nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
　　　　signature: res.data.signature,// 必填，签名，见附录1
　　　　jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
　　});

    wx.error(function(res){
      console.log("微信JS SDK调用失败",res)
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    });
    })

    this.device = this.$store.state.device;
    console.log("device", this.device);
    if (this.device.id == null) {
      console.log("location", 111);
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        (r) => {
          if (r.point) {
            this.location.lng = r.longitude;
            this.location.lat = r.latitude;
            this.location.page = 0;
            this.location.size = 1;
            getDevices(this.location).then((res) => {
              console.log(res.data);
              this.devices = res.data;
              var point = [];
              if (res.data.length > 0) {
                var obj = {
                  id: res.data[0].content.name.id,
                  name: res.data[0].content.name.name,
                  address: res.data[0].content.name.address,
                  lat: res.data[0].content.name.lat,
                  lng: res.data[0].content.name.lng,
                  numberCode: res.data[0].content.name.numberCode,
                };
                this.$store.commit("setDevice", obj);
                this.device = this.$store.state.device;
                this.handleBooks(this.device.id);
              }
            });
          }
        },
        { enableHighAccuracy: true }
      );
    } else {
      this.handleBooks(this.device.id);
    }
  },
};
</script>

<style lang="css" scoped>
.main {
  padding-left: 0;
  padding-right: 0;
}
.main .mt {
  padding: 0.32rem 0.3rem 0;
}
.main .mt .location {
  color: #f3bd00;
  margin-right: 1.2rem;
}
.main .mt .location img {
  margin: 0 0.16rem 0 0.12rem;
  height: 0.38rem;
  vertical-align: middle;
}
.main .mt .btn-nav {
  float: right;
  text-align: right;
  font-size: 0.24rem;
  line-height: 0.38rem;
  color: #777777;
}
.main .mc .hd {
  padding: 0.32rem 0.3rem 0.16rem;
}
.main .mc .search-box {
  position: relative;
}
.main .mc .search-box > img {
  position: absolute;
  height: 0.34rem;
  top: 50%;
  margin-top: -0.17rem;
  left: 0.28rem;
}
.main .mc .search-box input {
  width: 100%;
  height: 0.78rem;
  border: none;
  background: #4d4a55;
  border-radius: 0.08rem;
  outline: none;
  font-size: 0.26rem;
  line-height: 0.78rem;
  color: #d9d7dd;
  padding: 0 0.3rem 0 0.9rem;
}
.main .mc .search-box ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #858585;
}
.main .mc .search-box ::-moz-placeholder {
  /* Firefox 19+ */
  color: #858585;
}
.main .mc .search-box :-ms-input-placeholder {
  /* IE 10+ */
  color: #858585;
}
.main .mc .search-box :-moz-placeholder {
  /* Firefox 18- */
  color: #858585;
}
.main .mc .bd .tab {
  border-bottom: 0.02rem solid #4c4a57;
  margin: 0 0.55rem;
  overflow: hidden;
}
.main .mc .bd .tab li {
  float: left;
  margin-right: 0.4rem;
}
.main .mc .bd .tab li a {
  display: inline-block;
  padding: 0.2rem 0.18rem 0.3rem;
  font-size: 0.24rem;
  color: #d9d7dd;
}
.main .mc .bd .tab li.active a {
  border-bottom: 0.05rem solid #f3bd00;
  color: #f3bd00;
}
.main .mc .bd .bookList {
  margin: 0 0.2rem;
  overflow: hidden;
  padding-bottom: 0.2rem;
}
.main .mc .bd .bookList li {
  margin-top: 0.36rem;
  float: left;
  width: 33.333333%;
  padding: 0 0.38rem;
}
.main .mc .bd .bookList li .bookItem {
  display: block;
}
.main .mc .bd .bookList li .bookItem img {
  width: 100%;
}
.main .mc .bd .bookList li .bookItem p {
  margin-top: 0.2rem;
  color: #d9d7dd;
  text-align: center;
  font-size: 0.18rem;
  font-weight: bolder;
}
</style>
